"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var pagerTypes_exports = {};
__export(pagerTypes_exports, {
  validatePage: () => validatePage,
  validatePager: () => validatePager
});
module.exports = __toCommonJS(pagerTypes_exports);
function validatePager(param) {
  var { initialPage = 0, pageMargin = 0, offscreenPageLimit, orientation = "horizontal", layoutDirection = "ltr", keyboardDismissMode = "none", overScrollMode = "auto" } = param;
  validatePage(initialPage);
  if (!Number.isFinite(pageMargin) || pageMargin < 0) throw new Error("Pager.pageMargin must be a finite nonnegative number");
  if (offscreenPageLimit !== void 0 && offscreenPageLimit !== -1 && (!Number.isInteger(offscreenPageLimit) || offscreenPageLimit < 1)) throw new Error("Pager.offscreenPageLimit must be -1 or a positive integer");
  if (orientation !== "horizontal" && orientation !== "vertical") throw new Error("Pager.orientation must be horizontal or vertical");
  if (layoutDirection !== "ltr" && layoutDirection !== "rtl") throw new Error("Pager.layoutDirection must be ltr or rtl");
  if (keyboardDismissMode !== "none" && keyboardDismissMode !== "on-drag") throw new Error("Pager.keyboardDismissMode must be none or on-drag");
  if (![
    "auto",
    "always",
    "never"
  ].includes(overScrollMode)) throw new Error("Pager.overScrollMode must be auto, always or never");
}
function validatePage(index) {
  if (!Number.isInteger(index) || index < 0 || index > 2147483647) throw new Error("Pager page index must be a nonnegative 32-bit integer");
}
//# sourceMappingURL=pagerTypes.js.map
